module.exports = __webpack_public_path__ + "media/components/footer/static/mfc--white-ccbf9d990be9665fc6abfe054f175f9e.svg";